import primaryButton from '../../../../primary-button';

const secondary = (params) => primaryButton.solidIcon.background.disabled.secondary(params);

export default secondary;
